/**
 * The preset amounts every giving form on this site offers — **10, 30, 50 and 100**, then a
 * custom box, which `DonateAmountPicker` always appends.
 *
 * Set by the Foundation on 2026-09-25; they were 10, 20, 30, 40 and 50. One list for the
 * directory's panel, `/donations/:slug` and the band beneath the directory, so the three
 * cannot offer different amounts for the same appeal.
 *
 * `DONATION_DETAIL` went the same day — the template's static "$10.00" display, "Donation
 * Total: $10" and the three payment methods. None of it was wired, the display did not follow
 * the picker, and the methods were a choice PayPal's own window makes.
 */
export const DONATE_AMOUNTS = [10, 30, 50, 100]
